"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamPlayerStats = exports.Stats = exports.LegacyHoopsStat = exports.HoopsStat = void 0;
var tslib_1 = require("tslib");
var Immutable = tslib_1.__importStar(require("immutable"));
var utilities = tslib_1.__importStar(require("../multi_sport_common/utilities"));
var definitions_1 = require("../common/definitions");
var definitions_2 = require("../multi_sport_common/events/definitions");
var definitions_3 = require("./events/definitions");
var HoopsStat;
(function (HoopsStat) {
    HoopsStat["FGM"] = "FGM";
    HoopsStat["FGA"] = "FGA";
    HoopsStat["FGP"] = "FG%";
    HoopsStat["M2PT"] = "2PTM";
    HoopsStat["A2PT"] = "2PTA";
    HoopsStat["P2PT"] = "2PT%";
    HoopsStat["M3PT"] = "3PTM";
    HoopsStat["A3PT"] = "3PTA";
    HoopsStat["P3PT"] = "3PT%";
    HoopsStat["FTM"] = "FTM";
    HoopsStat["FTA"] = "FTA";
    HoopsStat["FTP"] = "FT%";
    HoopsStat["REB"] = "REB";
    HoopsStat["ORB"] = "ORB";
    HoopsStat["DRB"] = "DRB";
    HoopsStat["AST"] = "AST";
    HoopsStat["STL"] = "STL";
    HoopsStat["PF"] = "PF";
    HoopsStat["TF"] = "TF";
    HoopsStat["TO"] = "TO";
    HoopsStat["PTS"] = "PTS";
    HoopsStat["GP"] = "GP";
    HoopsStat["GS"] = "GS";
    HoopsStat["BLK"] = "BLK";
    HoopsStat["TMO"] = "TMO";
    HoopsStat["TMO30"] = "TMO30";
    HoopsStat["PM"] = "+/-";
    HoopsStat["AST2TO"] = "AST/TO";
    HoopsStat["TSP"] = "TS%";
    HoopsStat["EFGP"] = "eFG%";
    // Averages per game
    HoopsStat["REBPG"] = "RPG";
    HoopsStat["ASTPG"] = "APG";
    HoopsStat["STLPG"] = "SPG";
    HoopsStat["BLKPG"] = "BPG";
    HoopsStat["PFPG"] = "PFPG";
    HoopsStat["TOPG"] = "TOPG";
    HoopsStat["PTSPG"] = "PPG";
})(HoopsStat = exports.HoopsStat || (exports.HoopsStat = {}));
var LegacyHoopsStat;
(function (LegacyHoopsStat) {
    // Counting stats calculated by legacy, but not yet calculated by modern
    LegacyHoopsStat["OF"] = "OF";
    LegacyHoopsStat["FF"] = "FF";
    LegacyHoopsStat["PT2C"] = "2CP";
    LegacyHoopsStat["PTOTO"] = "POT";
    LegacyHoopsStat["PIP"] = "PIP";
    // Average stats calculated by legacy, but not yet calculated by modern
    LegacyHoopsStat["M3PTPFGA"] = "3PTM/FGA";
    LegacyHoopsStat["TSA"] = "TSA";
    LegacyHoopsStat["A2PTPG"] = "2PTAPG";
    LegacyHoopsStat["A3PTPG"] = "3PTAPG";
    LegacyHoopsStat["M2PTPG"] = "2PTMPG";
    LegacyHoopsStat["M3PTPG"] = "3PTMPG";
    LegacyHoopsStat["FGMPG"] = "FGMPG";
    LegacyHoopsStat["FGAPG"] = "FGAPG";
    LegacyHoopsStat["FTMPG"] = "FTMPG";
    LegacyHoopsStat["FTAPG"] = "FTAPG";
    LegacyHoopsStat["FTAPFGA"] = "FTA/FGA";
    LegacyHoopsStat["OFPG"] = "OFPG";
    LegacyHoopsStat["TFPG"] = "TFPG";
    LegacyHoopsStat["FFPG"] = "FFPG";
})(LegacyHoopsStat = exports.LegacyHoopsStat || (exports.LegacyHoopsStat = {}));
var Stats;
(function (Stats) {
    function values() {
        return Object.values(HoopsStat);
    }
    Stats.values = values;
    function empty() {
        // Calculate derived values to fully initialize all stats
        return calculateDerived(Stats.values().reduce(function (previous, key) {
            return previous.set(key, 0);
        }, Immutable.Map()));
    }
    Stats.empty = empty;
    function addPlay(stats, playCode) {
        if ((0, definitions_2.isValidPlayCode)(playCode, definitions_3.HOOPS_CONFIGURATION.play_codes)) {
            return compoundPlays(true, stats, playCode);
        }
        else {
            utilities.unreachablePlayCode(playCode);
        }
    }
    Stats.addPlay = addPlay;
    function removePlay(stats, playCode) {
        if ((0, definitions_2.isValidPlayCode)(playCode, definitions_3.HOOPS_CONFIGURATION.play_codes)) {
            return compoundPlays(false, stats, playCode);
        }
        else {
            utilities.unreachablePlayCode(playCode);
        }
    }
    Stats.removePlay = removePlay;
    function averageKey(stat) {
        switch (stat) {
            case HoopsStat.REB:
                return HoopsStat.REBPG;
            case HoopsStat.AST:
                return HoopsStat.ASTPG;
            case HoopsStat.STL:
                return HoopsStat.STLPG;
            case HoopsStat.BLK:
                return HoopsStat.BLKPG;
            case HoopsStat.PF:
                return HoopsStat.PFPG;
            case HoopsStat.TO:
                return HoopsStat.TOPG;
            case HoopsStat.PTS:
                return HoopsStat.PTSPG;
            default:
                return undefined;
        }
    }
    Stats.averageKey = averageKey;
    function compoundPlays(increment, stats, playCode) {
        return calculateDerived((function () {
            switch (playCode) {
                case definitions_3.PlayCode.Made2:
                    return compoundStats(increment, stats, HoopsStat.FGM, HoopsStat.FGA, HoopsStat.M2PT, HoopsStat.A2PT);
                case definitions_3.PlayCode.Made3:
                    return compoundStats(increment, stats, HoopsStat.FGM, HoopsStat.FGA, HoopsStat.A3PT, HoopsStat.M3PT);
                case definitions_3.PlayCode.MadeFreeThrow:
                    return compoundStats(increment, stats, HoopsStat.FTM, HoopsStat.FTA);
                case definitions_3.PlayCode.Missed2:
                    return compoundStats(increment, stats, HoopsStat.FGA, HoopsStat.A2PT);
                case definitions_3.PlayCode.Missed3:
                    return compoundStats(increment, stats, HoopsStat.FGA, HoopsStat.A3PT);
                case definitions_3.PlayCode.MissedFreeThrow:
                    return compoundStats(increment, stats, HoopsStat.FTA);
                case definitions_3.PlayCode.Assist:
                    return compoundStats(increment, stats, HoopsStat.AST);
                case definitions_3.PlayCode.Foul:
                    return compoundStats(increment, stats, HoopsStat.PF);
                case definitions_3.PlayCode.TechnicalFoul:
                    return compoundStats(increment, stats, HoopsStat.TF, HoopsStat.PF);
                case definitions_3.PlayCode.Rebound:
                    return compoundStats(increment, stats, HoopsStat.REB);
                case definitions_3.PlayCode.OffensiveRebound:
                    return compoundStats(increment, stats, HoopsStat.REB, HoopsStat.ORB);
                case definitions_3.PlayCode.DefensiveRebound:
                    return compoundStats(increment, stats, HoopsStat.REB, HoopsStat.DRB);
                case definitions_3.PlayCode.Steal:
                    return compoundStats(increment, stats, HoopsStat.STL);
                case definitions_3.PlayCode.Turnover:
                    return compoundStats(increment, stats, HoopsStat.TO);
                case definitions_3.PlayCode.Block:
                    return compoundStats(increment, stats, HoopsStat.BLK);
                case definitions_3.PlayCode.Timeout:
                    return compoundStats(increment, stats, HoopsStat.TMO);
                case definitions_3.PlayCode.Timeout30:
                    return compoundStats(increment, stats, HoopsStat.TMO30);
                default:
                    utilities.unreachablePlayCode(playCode);
            }
        })());
    }
    function compoundStats(increment, currentStats) {
        var statTypes = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            statTypes[_i - 2] = arguments[_i];
        }
        return statTypes.reduce(function (stats, statType) { return stats.updateIn([statType], 0, function (value) { return (increment ? ++value : --value); }); }, currentStats);
    }
})(Stats = exports.Stats || (exports.Stats = {}));
var TeamPlayerStats;
(function (TeamPlayerStats) {
    /**
     * Called by Eden when aggregating stats over several games for team and player season stats
     * @param baseStats aggregated stats on the server of several games compounded.
     */
    function getDerivedMultiGameStatsWithBaseStats(baseStats) {
        // Pull team points out first, TeamPlayerStats.toTeamsStatDoc takes them as an argument to compensate for score overrides.
        var teamPoints = Object.entries(baseStats).reduce(function (reduction, _a) {
            var teamId = _a[0], teamStats = _a[1];
            return reduction.setIn([teamId], teamStats.stats.offense[HoopsStat.PTS]);
        }, Immutable.Map.of());
        var teamPlayerStats = TeamPlayerStats.fromTeamsStatDoc(baseStats, true);
        return TeamPlayerStats.toTeamsStatDoc(teamPlayerStats, teamPoints);
    }
    TeamPlayerStats.getDerivedMultiGameStatsWithBaseStats = getDerivedMultiGameStatsWithBaseStats;
    /**
     * Empty TeamPlayerStats for the teams passed in.
     * @param teams the teams to generate empty stats for.
     */
    function fromTeams(teams) {
        return teams.toJS().reduce(function (previous, key) {
            var playerMap = Immutable.Map()
                .set(definitions_1.TOTAL, Stats.empty())
                .set(definitions_1.UNASSIGNED_PLAYER, Stats.empty());
            return previous.set(key, playerMap);
        }, Immutable.Map());
    }
    TeamPlayerStats.fromTeams = fromTeams;
    /**
     * Converts from immutable representation of stats for a team to typeDef used by clients.
     * @param stats immutable stats source.
     * @param teamPoints points scored by the team including overrides that are not accounted for by raw play events.
     */
    function toTeamsStatDoc(stats, teamPoints) {
        return teamPoints.reduce(function (doc, actualTotalPoints, teamId) {
            var calculatedTotalPoints = stats.getIn([teamId, definitions_1.TOTAL, HoopsStat.PTS]);
            var calculatedUnassignedPoints = stats.getIn([teamId, definitions_1.UNASSIGNED_PLAYER, HoopsStat.PTS]);
            // Player points are unaffected by manual score adjustments
            var actualPlayerPoints = calculatedTotalPoints - calculatedUnassignedPoints;
            var actualUnassignedPoints = actualTotalPoints - actualPlayerPoints;
            // Account for discrepancies caused by manual score adjustments
            var adjustedTeamPlayerStats = stats
                .setIn([teamId, definitions_1.TOTAL, HoopsStat.PTS], actualTotalPoints)
                .setIn([teamId, definitions_1.UNASSIGNED_PLAYER, HoopsStat.PTS], actualUnassignedPoints);
            doc[teamId] = playerStatsToTeamStatDoc(adjustedTeamPlayerStats.get(teamId));
            return doc;
        }, {});
    }
    TeamPlayerStats.toTeamsStatDoc = toTeamsStatDoc;
    /**
     * Converts from the client side stat typeDef to the immutable representation for calculations.
     * @param doc client stat source.
     * @param calculateAverages whether or not to calculate averages for stat keys that support them
     */
    function fromTeamsStatDoc(doc, calculateAverages) {
        return Object.entries(doc).reduce(function (teamPlayerStats, _a) {
            var teamId = _a[0], _b = _a[1], stats = _b.stats, unassigned = _b.unassigned, players = _b.players;
            var result = Object.entries(players)
                .reduce(function (accumulatedTeamPlayerStats, _a) {
                var playerId = _a[0], playerStats = _a[1];
                return accumulatedTeamPlayerStats.setIn([teamId, playerId], statDocumentToStats(playerStats.stats, !!calculateAverages));
            }, teamPlayerStats)
                .setIn([teamId, definitions_1.TOTAL], statDocumentToStats(stats, !!calculateAverages));
            return unassigned
                ? result.setIn([teamId, definitions_1.UNASSIGNED_PLAYER], statDocumentToStats(unassigned.stats, false))
                : result;
        }, Immutable.fromJS({}));
    }
    TeamPlayerStats.fromTeamsStatDoc = fromTeamsStatDoc;
    /**
     * Subtracts stat b from stat a  and returns the result.
     */
    function subtract(a, b) {
        return a.reduce(function (difference, _, teamId) {
            return difference.setIn([teamId], subtractPlayers(a.get(teamId), b.get(teamId)));
        }, Immutable.Map());
    }
    TeamPlayerStats.subtract = subtract;
    function subtractPlayers(a, b) {
        return a.reduce(function (difference, _, playerId) {
            return difference.setIn([playerId], subtractStats(a.get(playerId), b.get(playerId, Stats.empty())));
        }, Immutable.Map());
    }
    function subtractStats(a, b) {
        return calculateDerivedNoPoints(a.reduce(function (difference, _, stat) {
            return difference.setIn([stat], a.get(stat) - b.get(stat, 0));
        }, Stats.empty()), undefined);
    }
    function statDocumentToStats(statDocument, calculateAverages) {
        return calculateDerivedNoPoints(Immutable.fromJS(statDocument.offense), calculateAverages);
    }
    function playerStatsToTeamStatDoc(playerStats) {
        return playerStats.reduce(function (doc, stats, playerId) {
            switch (playerId) {
                case definitions_1.TOTAL:
                case definitions_1.UNASSIGNED_PLAYER:
                    return doc;
                default:
                    doc.players[playerId] = statsToPlayerStatsDoc(stats);
                    return doc;
            }
        }, {
            players: {},
            unassigned: statsToPlayerStatsDoc(playerStats.get(definitions_1.UNASSIGNED_PLAYER)),
            stats: statsToStatDocument(playerStats.get(definitions_1.TOTAL)),
        });
    }
    function statsToPlayerStatsDoc(stats) {
        return {
            stats: statsToStatDocument(stats),
        };
    }
    function statsToStatDocument(stats) {
        return {
            offense: stats.toJS(),
        };
    }
})(TeamPlayerStats = exports.TeamPlayerStats || (exports.TeamPlayerStats = {}));
// TypeScript namespacing is fickle, ideally the below would be in the Stats namespace,
// but they cant be used outside the namespace without being exported
/**
 * Used when converting from TeamPlayerStats to TeamsStatDoc and points are considered a derived property.
 * This is used to accurately tally up point totals for players as their point totals are fully derived.
 * Calculates other derived stats too.
 *
 * Unassigned plays and team totals on the other hand are affected by manual point adjustments and will
 * subsequently have their values overridden by the actual total team points.
 * @param stats the stats to calculated derived values for
 * @see getDerivedMultiGameStatsWithBaseStats
 * @see toTeamsStatDoc
 */
function calculateDerived(stats) {
    return calculateAdvancedStats(stats, calculateTotalPoints, calculateDerivedNoPoints);
}
function calculateAdvancedStats(stats) {
    var calculations = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        calculations[_i - 1] = arguments[_i];
    }
    return calculations.reduce(function (aggregated, calculation) { return calculation(aggregated); }, stats);
}
function calculateTotalPoints(stats) {
    var valGetter = function (stat) { return stats.get(stat, 0); };
    var totalPointsCalculation = valGetter(HoopsStat.FTM) + valGetter(HoopsStat.M2PT) * 2 + valGetter(HoopsStat.M3PT) * 3;
    return stats.setIn([HoopsStat.PTS], totalPointsCalculation);
}
/**
 * Used when converting from TeamsStatDoc to TeamPlayerStats or subtracting TeamPlayerStats.
 * Points are not considered a derived property in this case, as that was already taken into account
 * in a previous conversion.
 * @param stats the stats to calculated derived values for
 * @param calculateAverages Whether or not to calculate averages for the stats
 * @see statDocumentToStats
 * @see subtractStats
 */
function calculateDerivedNoPoints(stats, calculateAverages) {
    var valGetter = function (stat) { return stats.get(stat, 0); };
    var division = function (numerator, denominator) { return valGetter(numerator) / valGetter(denominator); };
    var derived = stats
        .setIn([HoopsStat.FGP], division(HoopsStat.FGM, HoopsStat.FGA))
        .setIn([HoopsStat.P2PT], division(HoopsStat.M2PT, HoopsStat.A2PT))
        .setIn([HoopsStat.P3PT], division(HoopsStat.M3PT, HoopsStat.A3PT))
        .setIn([HoopsStat.FTP], division(HoopsStat.FTM, HoopsStat.FTA));
    derived = calculateAdvancedStats(derived, calculateAssistToTurnoverRatio, calculateTrueShootingPercentage, calculateEffectiveShootingPercentage);
    if (calculateAverages) {
        return Stats.values().reduce(function (withAverages, stat) {
            var averageKey = Stats.averageKey(stat);
            return averageKey ? withAverages.setIn([averageKey], division(stat, HoopsStat.GP)) : withAverages;
        }, derived);
    }
    else {
        return derived;
    }
}
function calculateAssistToTurnoverRatio(stats) {
    var valGetter = function (stat) { return stats.get(stat, 0); };
    var division = function (numerator, denominator) { return valGetter(numerator) / valGetter(denominator); };
    return stats.setIn([HoopsStat.AST2TO], division(HoopsStat.AST, HoopsStat.TO));
}
function calculateTrueShootingPercentage(stats) {
    var valGetter = function (stat) { return stats.get(stat, 0); };
    var trueShootingCalculation = (0.5 * valGetter(HoopsStat.PTS)) / (valGetter(HoopsStat.FGA) + 0.44 * valGetter(HoopsStat.FTA));
    return stats.setIn([HoopsStat.TSP], trueShootingCalculation);
}
function calculateEffectiveShootingPercentage(stats) {
    var valGetter = function (stat) { return stats.get(stat, 0); };
    var effectiveShootingPercentage = (valGetter(HoopsStat.FGM) + 0.5 * valGetter(HoopsStat.M3PT)) / valGetter(HoopsStat.FGA);
    return stats.setIn([HoopsStat.EFGP], effectiveShootingPercentage);
}
//# sourceMappingURL=stats.js.map